import session from './session';

export default {
	session
}